<template>
  <div class="row justify-content-md-between align-items-md-center mx-3">
    <div class="col-xl-7">{{ startIndex }} - {{ endIndex }}</div>
    <div class="col-xl-5">
      <div class="text-md-right float-xl-right mt-2 pagination-rounded">
        <pagination v-model="page" :per-page="perPage" :records="rows" :options="options" />
      </div>
    </div>
  </div>
</template>

<script>
import Pagination from 'vue-pagination-2'

export default {
  name: 'paging',

  components: {
    Pagination,
  },

  props: {
    perPage: {
      type: Number,
      default: 30,
    },
    rows: Number,
    value: Number,
  },

  data() {
    return {
      page: this.value,
      startIndex: 1,
      endIndex: 30,
      pageKey: 0,
      loaded: false,
      options: {
        texts: {
          count: '',
        },
      },
    }
  },

  watch: {
    page() {
      if (this.loaded) {
        this.initIndex()
        const query = { ...this.$route.query }
        query.page = this.page
        this.$router.replace({ query })
      }
      this.$emit('input', this.page)
    },

    value() {
      this.page = this.value
    },
  },

  async mounted() {
    this.initPage()
    await this.$nextTick()
    this.loaded = true
  },

  methods: {
    initIndex() {
      this.endIndex = this.perPage * this.page
      this.startIndex = this.perPage * this.page - this.perPage + 1
    },

    initPage() {
      if (this.$route.query.page) {
        this.page = Number(this.$route.query.page)
      }
      this.initIndex()
    },
  },
}
</script>

<style scoped></style>
